import { useTranslation } from '@hooks/useTranslation'
import { collectionMeta, toy } from '@specs/specs'
import React, { FC } from 'react'
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate'
import { Button, ButtonProps } from '@components/UIKit/Button/Button'
import { LinksEnum, replaceQuery } from '@specs/navigation'
import { useRouter } from 'next/router'
import { useCollectBonus } from '@hooks/TRPC_Hooks/useCollectBonus'

interface CollectButtonProps extends Omit<ButtonProps, 'children'> {
    toyId: toy['id']
    collectionId: collectionMeta['id']
    slug: string
}

export const CollectBonusToyButton: FC<CollectButtonProps> = ({ toyId, collectionId, slug, ...props }) => {
    const router = useRouter()
    const { translate: tr } = useTranslation()
    const { updateStoreItemsData } = useInvalidate()
    const { mutateAsync: collectBonus } = useCollectBonus()
    const clickHandler = async () => {

        const data = await collectBonus({ toyId, collectionId })
        if (data?.status === 'success') {
            updateStoreItemsData({ toyId })
            replaceQuery(router, { collectToyStatus: 'success' })

            if (router.pathname === LinksEnum.EXPLORE_COLLECTION) {
                await router.push(
                    {
                        pathname: LinksEnum.TOY,
                        query: { slug, collectToyStatus: 'success' },
                    },
                    LinksEnum.TOY.replace('[slug]', slug),
                )
            }
        }
    }

    return (
        <Button
            {...props}
            onClick={clickHandler}
        >
            {tr({ id: 'btn.collect.now' })}
        </Button>
    )
}
